var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "whatsapp_svg__a",
    d: "M0 0h20.48v20.48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "whatsapp_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#whatsapp_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.201 14.46c-.247.698-1.228 1.276-2.01 1.445-.535.114-1.234.205-3.586-.77-3.01-1.247-4.947-4.305-5.098-4.503-.145-.199-1.216-1.62-1.216-3.089 0-1.47.746-2.185 1.047-2.492.247-.252.655-.367 1.047-.367.126 0 .24.006.343.011.3.013.451.03.65.506.247.595.849 2.064.92 2.215.073.151.146.356.044.555-.096.204-.18.295-.332.47-.15.173-.294.307-.445.493-.138.163-.295.337-.12.638.174.294.775 1.276 1.66 2.064 1.144 1.018 2.07 1.343 2.402 1.481.247.103.542.079.722-.113.23-.248.512-.657.8-1.06.205-.29.463-.325.735-.223.276.096 1.74.82 2.04.969.301.151.5.223.572.35.072.126.072.721-.175 1.42M10.243 0h-.006C4.591 0 0 4.593 0 10.24c0 2.24.722 4.316 1.95 6.002L.672 20.046l3.936-1.258a10.151 10.151 0 0 0 5.634 1.692c5.646 0 10.237-4.594 10.237-10.24S15.889 0 10.243 0",
    fill: "#747E86",
    mask: "url(#whatsapp_svg__b)"
  }))));
};
export default SvgWhatsapp;